import { emptySplitApi } from "./index";
import { getTeamKeyStorage } from "src/utils/token";

// Define a service using a base URL and expected endpoints
export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // 钉钉扫码登录
    postDingLogin: builder.mutation({
      query: (params) => {
        return {
          url: "/api-v2/login/ding-talk-user-token",
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(params).toString(),
        };
      },
    }),
    // 钉钉登录
    ddLogin: builder.mutation({
      query: (params) => {
        return {
          url: "/api-v2/login/ding-talk-code",
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(params).toString(),
        };
      },
    }),
    // JSAPI鉴权
    getJsTicket: builder.query({
      query: ({ url }) => {
        return {
          url: `/api-v2/teams/${getTeamKeyStorage()}/ding-talk/auth-jsTicket?encodeUrl=${url}`,
          method: "GET",
        };
      },
    }),
    // 获取权限Key
    // https://test-ats.renlijia.com/doc.html#/default/%E6%9D%83%E9%99%90%E6%8E%A5%E5%8F%A3/getOpenJobsUsingGET_1
    getAuthCode: builder.query({
      query: (params) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/permission-key`,
        method: "GET",
        params,
      }),
    }),
    // 查询登录团队信息和已上传简历数量
    getTeamInfo: builder.query({
      query: () => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/current/team-info`,
      }),
      providesTags: ["upload", "users"],
    }),
    // 查询登录用户的钉钉帐户信息
    getDingUserInfo: builder.query({
      query: () => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/current/ding-talk-user-info`,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  usePostDingLoginMutation,
  useDdLoginMutation,
  useGetJsTicketQuery,
  useGetAuthCodeQuery,
  useGetTeamInfoQuery,
  useGetDingUserInfoQuery,
  useGetTeamsQuery,
} = authApi;
